import NewLayout from "@components/new-ui/Layout";
import React, { FC } from "react";

const CookiePolicy: FC = () => {
    return (
        <NewLayout
            title="Cookie Policy - Gallabox"
            description="Our cookie policy covers the use of cookies between your device and our site."
            canonical="https://gallabox.com/cookie-policy"
        >
            <section className="relative">
                <div className="absolute top-10 -left-10 w-32 h-32 rounded-full" style={{ backgroundColor: "#39FAD799", filter: "blur(5rem)" }} />
                <div className="absolute top-96 -right-10 w-32 h-32 rounded-full" style={{ backgroundColor: "#3364fb99", filter: "blur(5rem)" }} />

                <div className="text-base flex flex-col gap-10 max-w-4xl 2xl:max-w-6xl px-8 py-8 md:px-0 mx-auto">
                    <a href="/" className="focus:outline-none focus:shadow-outline mx-auto" aria-label="Gallabox">
                        <img alt="Gallabox" src="/gallabox-logo.png" className="mx-auto lg:mx-0 w-32" sizes="100%" />
                    </a>
                    <h1 className="text-2xl 2xl:text-3xl font-bold my-0 text-center">Cookie Policy</h1>
                    <section className="flex flex-col gap-4">
                        <p>
                            We use cookies to help improve your experience of our website at{" "}
                            <a href="https://gallabox.com" target="_blank" rel="noreferrer">
                                https://gallabox.com
                            </a>
                            . This cookie policy is part of Gallabox Global Inc&apos;s privacy policy. It covers the use of cookies between your device and our site.
                        </p>
                        <p>
                            We also provide basic information on third-party services we may use, who may also use cookies as part of their service. This policy does not cover
                            their cookies.
                        </p>
                        <p>
                            If you don’t wish to accept cookies from us, you should instruct your browser to refuse cookies from{" "}
                            <a href="https://gallabox.com" target="_blank" rel="noreferrer">
                                https://gallabox.com
                            </a>
                            . In such a case, we may be unable to provide you with some of your desired content and services.
                        </p>
                    </section>
                    <section className="flex flex-col gap-4">
                        <p>
                            <h2 className="text-base 2xl:text-lg font-bold my-0">What is a cookie?</h2>
                        </p>

                        <p>
                            A cookie is a small piece of data that a website stores on your device when you visit. It typically contains information about the website itself, a
                            unique identifier that allows the site to recognise your web browser when you return, additional data that serves the cookie’s purpose, and the lifespan
                            of the cookie itself.
                        </p>
                        <p>
                            Cookies are used to enable certain features (eg logging in), track site usage (eg analytics), store your user settings (eg time zone, notification
                            preferences), and to personalise your content (eg advertising, language).
                        </p>
                        <p>
                            Cookies set by the website you are visiting are usually referred to as first-party cookies. They typically only track your activity on that particular
                            site.
                        </p>
                        <p>
                            Cookies set by other sites and companies (i.e. third parties) are called third-party cookies They can be used to track you on other websites that use
                            the same third-party service.
                        </p>
                        <p>Types of cookies and how we use them,</p>
                        <p>
                            <span className="font-medium">Essential cookies</span>
                        </p>
                        <p>
                            Essential cookies are crucial to your experience of a website, enabling core features like user logins, account management, shopping carts, and payment
                            processing.
                        </p>
                        <p>We use essential cookies to enable certain functions on our website.</p>
                        <p>
                            <span className="font-medium">Performance cookies</span>
                        </p>
                        <p>
                            Performance cookies track how you use a website during your visit. Typically, this information is anonymous and aggregated, with information tracked
                            across all site users. They help companies understand visitor usage patterns, identify and diagnose problems or errors their users may encounter, and
                            make better strategic decisions in improving their audience’s overall website experience. These cookies may be set by the website you’re visiting
                            (first-party) or by third-party services. They do not collect personal information about you.
                        </p>
                        <p>We use performance cookies on our site.</p>
                        <p>
                            <span className="font-medium">Functionality cookies</span>
                        </p>
                        <p>
                            Functionality cookies are used to collect information about your device and any settings you may configure on the website you’re visiting (like language
                            and time zone settings). With this information, websites can provide you with customised, enhanced, or optimised content and services. These cookies may
                            be set by the website you’re visiting (first-party) or by third-party services.
                        </p>
                        <p>We use functionality cookies for selected features on our site.</p>
                        <p>
                            <span className="font-medium">Targeting/advertising cookies</span>
                        </p>
                        <p>
                            Targeting/advertising cookies help determine what promotional content is most relevant and appropriate to you and your interests. Websites may use them
                            to deliver targeted advertising or limit the number of times you see an advertisement. This helps companies improve the effectiveness of their campaigns
                            and the quality of content presented to you. These cookies may be set by the website you’re visiting (first-party) or by third-party services.
                            Targeting/advertising cookies set by third-parties may be used to track you on other websites that use the same third-party service.
                        </p>
                        <p>We do not use this type of cookie on our site.</p>
                    </section>
                </div>
            </section>
        </NewLayout>
    );
};

export default CookiePolicy;
